import styled from "styled-components";
import { basicColor } from "../GlobalStyle";

type CustomPasswordInputTypes = {
  fontFamily: string;
  border: string;
  padding: string;
  placeholderFamily: string;
  placeholderFont: string;
  fontSize: string;
  labelMarginBottom: string;
  labelFont: string;
  labelFamily: string;
};

export const CustomPasswordInputStyle = styled.div<CustomPasswordInputTypes>`
  label {
    font-size: ${(props) => props.labelFont};
    font-family: ${(props) => props.labelFamily};
    margin-bottom: ${(props) => props.labelMarginBottom};
  }

  .ant-input {
    font-family: ${(props) => props.fontFamily};
    font-size: ${(props) => props.fontSize};
    &::placeholder {
      font-family: ${(props) => props.placeholderFamily};
      font-size: ${(props) => props.placeholderFont};
    }
  }

  .customPasswordInput {
    background: white;
    border-radius: 8px !important;
    margin-bottom: 0px !important;
    padding: ${(props) => props.padding};
  }

  .ant-input-suffix span {
    font-size: 12px;
    font-weight: normal;
    color: ${basicColor};
    cursor: pointer;
    font-family: ${(props) => props.fontFamily};
  }
  .ant-input-affix-wrapper {
    border: ${(props) => props.border};
  }
`;

export default CustomPasswordInputStyle;
